import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import 'antd/dist/antd.css';
import { Col, Typography, Button, Modal, Select, Form, Input, Space, message, Spin } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { STATES, ROLES } from '../../config/constants/contractStates';
import { RESEND_MAIL, RESEND_MAIL_SUCESS } from '../../state/mail/types';
import { STATUS } from '../../config/constants/states';
import { RESOURCE } from '../../config/constants/alerts';
import { CLEAR_ERRORS } from '../../state/error/types';
import Alerts from '../alerts/Alerts';
import PropTypes from 'prop-types';

const { Text } = Typography;
const { Option } = Select;

const ReSendMail = ({ contract, resendMail, resendSucess, resetStatus, clearErrors }) => {

  const [form] = Form.useForm();
  const [modalVisible, setModalVisible] = useState(false);
  const [tittle, setTittle] = useState('');
  const [loaderSpinning, setLoaderSpinning] = useState(true);
  const [data, setData] = useState(JSON.stringify({ rol: ROLES.LESSOR }));

  useEffect(() => {
    setLoaderSpinning(false);
    if (resendSucess === STATUS.SUCCESS) {
      resetStatus();
      setModalVisible(false);
      message.success('Email enviado satisfactoriamente', 10);
    };
    if (resendSucess === STATUS.ERROR) {
      resetStatus();
    }
  }, [resendSucess]);

  const ShowEmail = (props) => {
    const data = JSON.parse(props.data);
    switch (data.rol) {
      case ROLES.LESSOR:
        return (
          <Col className='mb-4'>
            <Text strong>Email actual: {contract.arrendador.email}</Text>
          </Col>
        );
      case ROLES.LESSEE:
        return (
          <Col className='mb-4'>
            <Text strong>Email actual: {contract.arrendatario.email}</Text>
          </Col>
        );
      case ROLES.CODEBTOR:
        return (
          <Col className='mb-4'>
            <Text strong>Email actual: {contract.codeudor.email}</Text>
          </Col>
        );
      case ROLES.OWNER:
        return (
          <Col className='mb-4'>
            <Text strong>Email actual: {contract.owner.email}</Text>
          </Col>
        );
      case ROLES.LESSEES:
        return (
          <Col className='mb-4'>
            <Text strong>Email actual: {contract.arrendatarios[data.rol_idx].email}</Text>
          </Col>
        );
      case ROLES.CODEBTORS:
        return (
          <Col className='mb-4'>
            <Text strong>Email actual: {contract.codeudores[data.rol_idx].email}</Text>
          </Col>
        );
      default:
        return (<></>);
    }
  };

  const SendToOwner = () => (
    <React.Fragment>
      <Form.Item
        name="rol"
        label="Enviar a:"
        className="position-relative"
        initialValue={JSON.stringify({ rol: ROLES.OWNER })}
      >
        <Text strong>{contract.owner.nombre} (Propietario)</Text>
      </Form.Item>
      <ShowEmail data={JSON.stringify({ rol: ROLES.OWNER })} />
    </React.Fragment>
  );

  const SendTo = () => (
    <React.Fragment>
      <Form.Item
        name="rol"
        label="Enviar a:"
        className="position-relative"
        initialValue={JSON.stringify({ rol: ROLES.LESSOR })}
      >
        <Select defaultValue={JSON.stringify({ rol: ROLES.LESSOR })} style={{ width: '100%' }} onChange={(value) => { setData(value); }}>
          <Option key={ROLES.LESSOR} value={JSON.stringify({ rol: ROLES.LESSOR })}>{contract.arrendador.nombre} {contract.arrendador.apellido} (Arrendador)</Option>
          <Option key={ROLES.LESSEE} value={JSON.stringify({ rol: ROLES.LESSEE })}>{contract.arrendatario.nombre} {contract.arrendatario.apellido} (Arrendatario)</Option>
          {contract.arrendatarios && contract.arrendatarios[0] && (
            contract.arrendatarios.map((lessee, i) => <Option key={i} value={JSON.stringify({ rol: ROLES.LESSEES, rol_idx: i })}>{lessee.nombre} {lessee.apellido} (Arrendatario)</Option>)
          )}
          {contract.codeudor && <Option key={ROLES.CODEBTOR} value={JSON.stringify({ rol: ROLES.CODEBTOR })}>{contract.codeudor.nombre} {contract.codeudor.apellido} (Codeudor)</Option>}
          {contract.codeudores && contract.codeudores[0] && (
            contract.codeudores.map((codebtor, i) => <Option key={i} value={JSON.stringify({ rol: ROLES.CODEBTORS, rol_idx: i })}>{codebtor.nombre} {codebtor.apellido} (Codeudor)</Option>)
          )}
        </Select>
      </Form.Item>
      <ShowEmail data={data} />
    </React.Fragment>
  );

  const SendForm = () => {
    switch (contract.estado) {
      case STATES.CREATED:
      case STATES.AWAITING_VALIDATION:
        setTittle('validar');
        return (<SendTo />);
      case STATES.OBJECTED:
        setTittle('editar');
        return (<SendToOwner />);
      case STATES.AWAITING_SIGN:
        setTittle('firmar en Dec');
        return (<SendTo />);
      default:
        return (<></>);
    };
  };

  const formContent = (data) => {
    const rol = JSON.parse(data.rol);
    setLoaderSpinning(true);
    resendMail({
      email: data.email,
      ...rol,
      docID: contract._id
    });
  };

  return (
    <React.Fragment>
      {[STATES.CREATED, STATES.AWAITING_VALIDATION, STATES.AWAITING_SIGN, STATES.OBJECTED].includes(contract.estado) ?
        <React.Fragment>
          <Modal
            visible={modalVisible}
            title={`Reenviar mail para ${tittle}`}
            maskClosable={false}
            footer={null}
            onCancel={() => (setModalVisible(false))}
            afterClose={() => clearErrors()}
          >
            <Spin
              spinning={loaderSpinning}
              size="large"
            >
              <Alerts />
              <Form
                form={form}
                layout="vertical"
                onFinish={formContent}
                autoComplete="on"
              >
                <SendForm />
                <Form.Item
                  label="Actualizar email del usuario (opcional)"
                  name={'email'}
                  rules={[
                    {
                      pattern: new RegExp(/^\S+@\S+\.\S+$/),
                      message: 'Debes ingresar un correo válido'
                    }
                  ]}
                >
                  <Input size="large" autoComplete="off" />
                </Form.Item>
                <Col sm={24} className="d-flex justify-content-end">
                  <Space>
                    <Button onClick={() => setModalVisible(false)} >
                      Cancelar
                    </Button>
                    <Button type="primary" htmlType="submit" >
                      Reenviar mail
                    </Button>
                  </Space>
                </Col>
              </Form>
            </Spin>
          </Modal>
          <Button icon={<MailOutlined />} onClick={() => setModalVisible(true)} >
            Reenviar mail
          </Button>
        </React.Fragment>
        : <></>
      }
    </React.Fragment>
  );
};

ReSendMail.propTypes = {
  contract: PropTypes.object.isRequired,
  resendMail: PropTypes.func.isRequired,
  resendSucess: PropTypes.string.isRequired,
  resetStatus: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  data: PropTypes.object
};

const data = state => ({
  contract: state.contract.contract,
  resendSucess: state.mail.resendSucess
});

const actions = (dispatch) => ({
  resendMail: (data) => dispatch({ type: RESEND_MAIL, payload: { ...data, resource: RESOURCE.RESEND_MAIL } }),
  resetStatus: () => dispatch({ type: RESEND_MAIL_SUCESS, payload: STATUS.PENDING }),
  clearErrors: () => dispatch({ type: CLEAR_ERRORS }),
});

export default connect(data, actions)(ReSendMail);